
<app-srs-multi-element-widget *ngIf="formGroup" [config]="firstConfig"></app-srs-multi-element-widget>
